import { FormRow } from 'ia-react-core';
import { isNullOrWhitespaces } from 'omni-package-react-core';
import React, { FC } from 'react';
import ContractsControl from './ContractsControl';
import BusinessLinesControl from './BusinessLinesControl';
import { StyledBlockContractInfo } from './ContractRow.styles';
import ExcludedContractInformation from './ExcludedContractInformation';

export interface ContractRowProps {
  isClient: boolean;
  excludedContractMessage: string;
}

const ContractRow: FC<ContractRowProps> = ({ isClient, excludedContractMessage }) => (
  <>
    <FormRow>
      {isClient && (<ContractsControl />)}
      {!isClient && (<BusinessLinesControl />)}
    </FormRow>
    {!isNullOrWhitespaces(excludedContractMessage) && (
      <StyledBlockContractInfo nested p-b={36}>
        <ExcludedContractInformation message={excludedContractMessage} />
      </StyledBlockContractInfo>
    )}
  </>
);
export default ContractRow;
